
import { IAccessibleViewImplementation } from '../../../../platform/accessibility/browser/accessibleViewRegistry.js';

export class HoverAccessibleView implements IAccessibleViewImplementation {
}

export class HoverAccessibilityHelp implements IAccessibleViewImplementation {
}

export class ExtHoverAccessibleView implements IAccessibleViewImplementation {
}
